<template>
  <div class="con-wrap full-page" style="background-color: #fff">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="user">
          <el-input
            v-model="queryForm.user"
            @keyup.enter.native="query"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="plate">
          <el-input
            v-model="queryForm.plate"
            @keyup.enter.native="query"
            placeholder="请输入车牌号"
          ></el-input>
        </el-form-item>
        <el-button
          v-if="hasPerm('maintain:personnel:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('maintain:personnel:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          v-if="hasPerm('maintain:personnel:save')"
          type="primary"
          @click="addUser"
          >新增</el-button
        >
        <el-button
          size="medium"
          v-if="hasPerm('maintain:personnel:delete')"
          type="danger"
          @click="delUser"
          >删除</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="sex" label="性别">
        <template slot-scope="scope">
          <span v-if="scope.row.sex == 1">男</span>
          <span v-else-if="scope.row.sex == 2">女</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系电话"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="plateNum"
        label="车牌号"
        show-overflow-tooltip
        min-width="80"
      ></el-table-column>
      <el-table-column
        prop="maintainCompany"
        label="所属代维公司"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="deptName"
        label="使用部门"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="groupName"
        label="所属运维小组"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="belongMaintainStr"
        label="所属代维专业"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="situation" label="在职状态">
        <template slot-scope="scope">
          <span v-if="scope.row.situation == 1" class="btn-green">在职</span>
          <span v-else-if="scope.row.situation == 2" class="btn-orange"
            >试用期</span
          >
          <span v-else-if="scope.row.situation == 3" class="btn-red">离职</span>
          <span v-else></span>
        </template>
        <template slot="header">
          <span>在职状态</span>
          <span @click="situationChange" class="iconfont icon-sort"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="onlineTime"
        label="最新上线时间"
        min-width="140"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('maintain:personnel:driver')"
            @click.stop="queryElectrician(scope.row)"
            >电工证</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('maintain:personnel:driver')"
            @click.stop="queryDriver(scope.row)"
            >驾驶证</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('maintain:personnel:update')"
            @click.stop="editUser(scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="text"
            v-if="hasPerm('maintain:personnel:info')"
            @click.stop="getUserInfo(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 电工证弹窗 -->
    <el-dialog
      title="电工证"
      :visible.sync="electricianVisible"
      class="mini-dialog"
    >
      <p class="dialog-title">电工证正面</p>
      <div class="imgWrap" style="padding-bottom: 10px">
        <el-image
          style="width: 440px; height: 280px"
          :src="electricianUrl"
          :preview-src-list="electricianUrlList"
        >
        </el-image>
      </div>
      <p class="dialog-title">电工证反面</p>
      <div class="imgWrap">
        <el-image
          style="width: 440px; height: 280px"
          :src="viceElectricianUrl"
          :preview-src-list="viceElectricianUrlList"
        >
        </el-image>
      </div>
    </el-dialog>
    <!-- 驾驶证弹窗 -->
    <el-dialog title="驾驶证" :visible.sync="deiverVisible" class="mini-dialog">
      <p class="dialog-title">驾驶证主页</p>
      <div class="imgWrap" style="padding-bottom: 10px">
        <!-- <img :src="mainPageUrl" alt="暂未上传驾驶证主页" /> -->
        <el-image
          style="width: 440px; height: 280px"
          :src="mainPageUrl"
          :preview-src-list="mainPageUrlList"
        >
        </el-image>
      </div>
      <p class="dialog-title">驾驶证副页</p>
      <div class="imgWrap">
        <!-- <img :src="vicePageUrl" alt="暂未上传驾驶证副页" /> -->
        <el-image
          style="width: 440px; height: 280px"
          :src="vicePageUrl"
          :preview-src-list="vicePageUrlList"
        >
        </el-image>
      </div>
    </el-dialog>
    <!--新增运维人员对话框-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="submitVisible"
      class="small-dialog"
    >
      <el-form
        :rules="rules"
        ref="addUser"
        :model="StaffForm"
        class
        :inline="true"
      >
        <p class="dialog-title">必填信息</p>
        <el-form-item prop="name" label="姓名">
          <el-input
            v-model="StaffForm.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>

        <el-form-item prop="numberId" label="身份证号">
          <el-input
            v-model="StaffForm.numberId"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input
            v-model="StaffForm.phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item prop="deptId" label="运维公司">
          <el-select
            v-model="StaffForm.deptId"
            clearable
            placeholder="请选择运维公司"
          >
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <p class="dialog-title">非必填信息</p>
        <el-form-item prop="sex" label="性别">
          <el-select v-model="StaffForm.sex" clearable placeholder="请选择性别">
            <el-option
              v-for="item in sexList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="education" label="学历">
          <el-select
            v-model="StaffForm.education"
            clearable
            placeholder="请选择学历"
          >
            <el-option
              v-for="item in educationList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="belongMaintain" label="所属代维专业">
          <el-select
            v-model="StaffForm.belongMaintain"
            clearable
            placeholder="请选择所属代维专业"
          >
            <el-option
              v-for="item in majorList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="contractTime" label="合同到期时间">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="StaffForm.contractTime"
            type="date"
            placeholder="请选择合同到期时间"
          ></el-date-picker>
        </el-form-item>
        <!-- <div> -->
        <el-form-item prop="situation" label="在职状态">
          <el-select
            v-model="StaffForm.situation"
            clearable
            placeholder="请选择在职状态"
          >
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- </div> -->
        <el-form-item prop="nation" label="民族">
          <el-input
            v-model="StaffForm.nation"
            placeholder="请输入民族"
          ></el-input>
        </el-form-item>
        <el-form-item prop="hometown" label="籍贯">
          <el-input
            v-model="StaffForm.hometown"
            placeholder="请输入籍贯"
          ></el-input>
        </el-form-item>
        <el-form-item class="long-input" prop="addr" label="家庭住址">
          <el-input
            v-model="StaffForm.addr"
            placeholder="请输入家庭住址"
          ></el-input>
        </el-form-item>
        <el-form-item prop="entryTime" label="入职时间">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="StaffForm.entryTime"
            type="date"
            placeholder="请选择入职时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="skill" label="具备技能">
          <el-input
            v-model="StaffForm.skill"
            placeholder="请输入具备技能"
          ></el-input>
        </el-form-item>
        <el-form-item prop="postDuty" label="岗位职责">
          <el-input
            v-model="StaffForm.postDuty"
            placeholder="请输入岗位职责"
          ></el-input>
        </el-form-item>
        <el-form-item prop="insurance" label="购买保险情况">
          <el-input
            v-model="StaffForm.insurance"
            placeholder="请输入购买保险情况"
          ></el-input>
        </el-form-item>
        <el-form-item class="long-input" prop="remark" label="备注">
          <el-input
            v-model="StaffForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <!--详情对话框-->
    <el-dialog
      title="详情"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
    >
      <maintenance-info :formData.sync="staffInfo"></maintenance-info>
    </el-dialog>
  </div>
</template>

<script>
import MaintenanceInfo from "@/components/MaintenanceInfo.vue";
export default {
  components: { MaintenanceInfo },
  data() {
    return {
      queryForm: {
        user: "",
        plate: "",
      },
      StaffForm: {
        name: "",
        education: "",
        sex: 1,
        numberId: "",
        phone: "",
        belongMaintain: "",
        contractTime: "",
        deptId: "",
        situation: "",
        nation: "",
        hometown: "",
        addr: "",
        entryTime: "",
        skill: "",
        postDuty: "",
        insurance: "",
        remark: "",
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入姓名",
          },
        ],
        education: [
          {
            required: false,
            trigger: "change",
            message: "请选择学历",
          },
        ],
        sex: [
          {
            required: false,
            trigger: "change",
            message: "请选择性别",
          },
        ],
        numberId: [
          { required: true, trigger: "change", message: "请输入身份证号" },
          {
            pattern: this.$formRules.IDCard,
            trigger: "blur",
            message: this.$formRules.IDCardMsg,
          },
        ],
        phone: [
          { required: true, trigger: "change", message: "请输入电话号码" },
          {
            pattern: this.$formRules.phone,
            trigger: "blur",
            message: this.$formRules.phoneMsg,
          },
        ],
        belongMaintain: [
          {
            required: false,
            trigger: "change",
            message: "请选择所属代维专业",
          },
        ],
        contractTime: [
          {
            required: false,
            trigger: "change",
            message: "请选择合同到期时间",
          },
        ],
        deptId: [
          {
            required: true,
            trigger: "change",
            message: "请选择运维公司",
          },
        ],
        situation: [
          {
            required: false,
            trigger: "change",
            message: "请选择在职状态",
          },
        ],
      },
      sexList: [
        {
          name: "男",
          value: 1,
        },
        {
          name: "女",
          value: 2,
        },
      ],
      //学历
      educationList: [],
      //代维专业
      majorList: [],
      //在职状态
      stateList: [
        {
          name: "在职",
          value: 1,
        },
        {
          name: "试用期",
          value: 2,
        },
        {
          name: "离职",
          value: 3,
        },
      ],
      //运维公司
      deptList: [],
      currentPage: 1,
      limit: 10,
      total: 0,
      // tableHeight: 0,
      tableData: [],
      tableVal: [],
      dialogTitle: "",
      submitVisible: false,
      editTag: "0",
      //合同到期时间
      contractTime: "",
      //入职时间
      entryTime: "",
      staffInfo: {},
      infoVisible: false,
      deiverVisible: false,
      electricianVisible: false,
      situationType: "",
      mainPageUrl: "",
      vicePageUrl: "",
      electricianUrl: "",
      viceElectricianUrl: "",
      mainPageUrlList: [],
      electricianUrlList: [],
      vicePageUrlList: [],
      viceElectricianUrlList: [],
    };
  },
  created() {
    this.getUserList();
    this.getCompanyList();
    this.getMajorList();
    this.getEducationList();
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.tableHeight = window.innerHeight - 400; //后面的50：根据需求空出的高度，自行调整
    // });
  },
  methods: {
    async getUserList() {
      let obj = {};
      obj.name = this.queryForm.user;
      obj.plate = this.queryForm.plate;
      obj.situation = this.situationType;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/personnel/list",
        { params: obj },
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    query() {
      this.getUserList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.situationType = "";
      this.getUserList();
    },
    addUser() {
      this.editTag = "0";
      //清空表单数据
      this.$resetForm(this, "addUser");
      //设置弹框标题
      this.dialogTitle = "新增运维人员";
      //显示提交弹框
      this.submitVisible = true;
    },
    editUser(row) {
      this.editTag = "1";
      //清空表单数据
      this.$resetForm(this, "addUser");
      //设置弹框标题
      this.dialogTitle = "编辑运维人员";
      //显示提交弹框
      this.submitVisible = true;
      //显示需要编辑的数据
      this.getStaffInfo(row.id);
    },
    saveOrUpdate() {
      let _this = this;
      let data = [];
      _this.$refs.addUser.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post(
              "/api/maintain/personnel",
              _this.StaffForm,
            );
          } else {
            data = await _this.$axios.patch(
              "/api/maintain/personnel",
              _this.StaffForm,
            );
          }
          let res = data.data;
          if (res.code == 1) {
            //信息提示
            _this.$message.success("操作成功");
            //刷新表格
            _this.getUserList();
            _this.submitVisible = false;
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    async delUser() {
      let _this = this;
      //多选删除
      let ids = _this.$getIds(_this.tableVal);
      if (!ids) {
        return;
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete(
            "/api/maintain/personnel",
            {
              data: JSON.stringify(ids),
            },
          );
          if (res.code == 1) {
            _this.$message.success("操作成功");
            let totalPage = Math.ceil((_this.total - 1) / 10);
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage;
            _this.currentPage = currentPage < 1 ? 1 : currentPage;
            _this.getUserList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    handleClickTableRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserList();
    },
    async getCompanyList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/personnel/company",
      );
      if (res.code == 1) {
        _this.deptList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getMajorList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "belongMaintain",
      );
      if (res.code == 1) {
        _this.majorList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getEducationList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "education",
      );
      if (res.code == 1) {
        _this.educationList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getStaffInfo(id) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/personnel/" + id,
      );
      if (res.code == 1) {
        _this.StaffForm = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //查询电工证
    async queryElectrician(rowData) {
      let _this = this;
      let id = rowData.id;
      this.electricianVisible = true;
      this.electricianUrl = "";
      this.viceElectricianUrl = "";
      this.electricianUrlList = [];
      this.viceElectricianUrlList = [];
      let { data: res } = await _this.$axios.get(
        "/api/sys/image/list?belongType=5&belongId=" + id,
      );
      if (res.code == 1) {
        let arr = res.data;
        for (let item in arr) {
          if (arr[item].belongType == 5) {
            if (arr[item].imageType == 2) {
              this.electricianUrl = arr[item].url;
              this.electricianUrlList.push(this.electricianUrl);
            } else if (arr[item].imageType == 3) {
              this.viceElectricianUrl = arr[item].url;
              this.viceElectricianUrlList.push(this.viceElectricianUrl);
            }
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //查询驾驶证
    async queryDriver(rowData) {
      let _this = this;
      let id = rowData.id;
      this.deiverVisible = true;
      this.mainPageUrl = "";
      this.vicePageUrl = "";
      this.mainPageUrlList = [];
      this.vicePageUrlList = [];
      let { data: res } = await _this.$axios.get(
        "/api/maintain/personnel/driver/" + id,
      );
      if (res.code == 1) {
        let arr = res.data;
        for (let item in arr) {
          if (arr[item].belongType == 1) {
            if (arr[item].imageType == 2) {
              this.mainPageUrl = arr[item].url;
              this.mainPageUrlList.push(this.mainPageUrl);
            } else if (arr[item].imageType == 3) {
              this.vicePageUrl = arr[item].url;
              this.vicePageUrlList.push(this.vicePageUrl);
            }
          }
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //列表详情弹窗内容
    async getUserInfo(rowData) {
      let id = rowData.id;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/personnel/" + id,
      );
      if (res.code == 1) {
        _this.staffInfo = [];
        _this.staffInfo = res.data;
        _this.staffInfo.sex = _this.staffInfo.sex == 1 ? "男" : "女";
        if (_this.staffInfo.situation == 1) {
          _this.staffInfo.situation = "在职";
        } else if (_this.staffInfo.situation == 2) {
          _this.staffInfo.situation = "试用期";
        } else if (_this.staffInfo.situation == 3) {
          _this.staffInfo.situation = "离职";
        }
      } else {
        _this.$message.warning(res.msg);
      }
      //显示弹框
      _this.infoVisible = true;
    },
    situationChange() {
      this.situationType = this.situationType == 1 ? 2 : 1;
      this.getUserList();
    },
  },
};
</script>

<style lang="scss" scoped>
.full-page {
  padding: 0 20px;
  background: #fff;
}
.small-dialog /deep/ .el-dialog {
  width: 900px;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.small-dialog /deep/ .el-form-item__content,
.el-date-editor.el-input {
  width: 240px;
  height: 32px;
}
// .small-dialog /deep/ .el-date-editor.el-input {
//   width: 240px;
//   height: 32px;
// }
.long-input /deep/ .el-form-item__content {
  width: 660px !important;
}
.small-dialog /deep/ .el-form-item__label {
  width: 170px;
  height: 32px;
  padding-left: 60px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
// 模态框样式设置
.info-box /deep/ .el-dialog {
  width: 900px;
  height: 540px;
}
.info-box /deep/ .el-dialog__body {
  color: #333;
}
.dialog-label {
  font-weight: bold;
}
.info-box /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
// 模态框样式设置
.info-box /deep/ .el-dialog {
  width: 900px;
  height: 540px;
}
.info-box /deep/ .el-dialog__body {
  color: #333;
}
.info-box /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
//驾驶证弹窗
.imgWrap {
  padding: 0 60px;
}
.imgWrap img {
  width: 440px;
  height: 280px;
}
</style>
